import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "inline"
};
const _hoisted_2 = {
  key: 0,
  class: "text-xs"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'Price',
  props: {
    value: null,
    perMonth: {
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createTextVNode(_toDisplayString(_ctx.$money(__props.value)) + " ", 1), __props.perMonth ? (_openBlock(), _createElementBlock("sub", _hoisted_2, "/" + _toDisplayString(_ctx.$t('month_short')), 1)) : _createCommentVNode("", true)]);
    };
  }
});